import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=c5329f48&scoped=true&class=mr-3&"
import script from "./teacher.vue?vue&type=script&lang=js&"
export * from "./teacher.vue?vue&type=script&lang=js&"
import style0 from "./teacher.vue?vue&type=style&index=0&id=c5329f48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5329f48",
  null
  
)

export default component.exports